<template>
  <div class="flex flex-col divide-y partner-form-mobile">
    <div class="w-full max-w-900px px-8 py-8 flex flex-col space-y-4">
      <div v-if="partner" class="flex flex-row items-center space-x-4">
        <VueUpload
          class="btn btn-xs btn-primary flex-grow max-w-150px cursor-pointer"
          ref="upload"
          :multiple="false"
          @input-filter="onInputFilter"
          @input-file="onInputFile"
        >
          <span class="text-white">Изменить логотип</span>
        </VueUpload>
      </div>
      <div class="flex flex-row items-start space-x-4">
        <div class="flex-grow flex-shrink-0 flex flex-col space-y-4">
          <Input
            label="Имя"
            v-model="payload.name"
            :invalid="$v.payload.name.$error"
          />
          <Input
            label="Email"
            v-model="payload.email"
            :invalid="$v.payload.email.$error"
          />
          <Input
            label="Процент"
            v-model="payload.order_percent"
            :invalid="$v.payload.order_percent.$error"
            :inputmask="{
              alias: 'numeric',
              rightAlign: false,
              allowMinus: false,
              placeholder: '',
              min: 0,
              max: 100,
              radixPoint: '',
            }"
          />
          <div class="flex flex-col space-y-2 pt-2">
            <Check
              v-model="payload.use_new_order_form"
              label="Использовать новую форму заказа"
            />
            <span class="text-12px text-gray-600">
              Выключено — используется текущая стабильная форма. Включено — новая форма V2.
            </span>
          </div>
          <Input
            label="Подпись в шапке новой формы (необязательно)"
            placeholder="Например: В партнёрстве с Ритуал Сервис"
            v-model="payload.order_form_caption"
          />
          <span class="text-12px text-gray-600 -mt-2">
            Оставьте пустым для собственной формы iWALY. Подпись показывается только в V2.
          </span>
        </div>
        <div class="flex-grow flex-shrink-0 flex flex-col space-y-4">
          <Input
            label="ИНН"
            v-model="payload.inn"
            :invalid="$v.payload.inn.$error"
          />
          <Input
            label="Сайт"
            v-model="payload.site"
            :invalid="$v.payload.site.$error"
          />
        </div>
      </div>
      <Input
        label="Как это работает? (HTML)"
        textarea
        v-model="payload.html"
        :invalid="$v.payload.html.$error"
      />
    </div>
    <div class="px-8 py-8 flex items-start space-x-4">
      <button
        class="btn btn-xs btn-outline-primary flex-grow max-w-150px"
        @click="$router.push({ name: 'partners' })"
      >
        Отменить
      </button>
      <button
        class="btn btn-xs btn-primary flex-grow max-w-150px"
        @click="onSaveClick"
      >
        Сохранить
      </button>
    </div>
  </div>
</template>

<script type="text/javascript">
import Input from '@/components/Input.vue';
import Check from '@/components/Check.vue';
import VueUpload from 'vue-upload-component';
import { uploadLogoById } from '@/api/partners';
import { iwalyNotify } from '@/notify';
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'PartnerForm',
  components: {
    Input,
    Check,
    VueUpload,
  },
  props: {
    defaultValue: {
      type: Object,
      required: false,
    },
    partnerId: {
      type: [String, Number],
      required: false,
    },
  },
  data() {
    return {
      img: [],
      payload: {
        name: '',
        inn: '',
        site: '',
        email: '',
        html: '',
        order_percent: '',
        use_new_order_form: false,
        order_form_caption: '',
      },
    };
  },
  validations: {
    payload: {
      name: {
        required,
      },
      inn: {
        required,
      },
      site: {
        required,
      },
      email: {
        required,
      },
      html: {
        required,
      },
      order_percent: {
        required,
      },
    },
  },
  computed: {
    partner() {
      return this.defaultValue;
    },
  },
  mounted() {
    if (this.defaultValue) {
      this.payload = {
        name: this.defaultValue.name ?? '',
        inn: this.defaultValue.inn ?? '',
        site: this.defaultValue.site ?? '',
        email: this.defaultValue.email ?? '',
        html: this.defaultValue.html ?? '',
        order_percent: this.defaultValue.percent ?? '',
        use_new_order_form: Boolean(this.defaultValue.use_new_order_form),
        order_form_caption: this.defaultValue.order_form_caption ?? '',
      };
    }
  },
  methods: {
    ...mapActions({
      fetchPartnerById: 'partners/ACT_FETCH_PARTNER_BY_ID',
    }),
    onSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('save', this.payload);
      }
    },
    onInputFilter(newOne, oldOne) {
      if (newOne && !oldOne) {
        // eslint-disable-next-line no-param-reassign
        newOne.blob = '';
        if ((window.URL || window.webkitURL) && URL.createObjectURL) {
          // eslint-disable-next-line no-param-reassign
          newOne.blob = URL.createObjectURL(newOne.file);
        }
      }
    },
    async onInputFile(e) {
      if (!this.partnerId) return;
      const file = e?.file;
      if (!file) return;
      const fd = new FormData();
      fd.append('logo', file);
      await uploadLogoById(this.partnerId, fd);
      await this.fetchPartnerById(this.partnerId);
      iwalyNotify.success({
        text: 'Логотип успешно обновлен!',
      });
    },
  },
};
</script>
